import * as React from 'react';

import { useNavigate } from "react-router-dom";
import MoreIcon from '@mui/icons-material/MoreVert';
import { Box, Button, Divider, IconButton, Menu, MenuItem, } from '@mui/material';
import { SimpleTreeView, TreeItem } from '@mui/x-tree-view';
import { ExpandMore } from '@mui/icons-material';
import { useProfile } from '../common/useProfile';

const MenuContent = ({ menuJson, edit, darkMode, style }) => {
    const navigate = useNavigate();
    const prof = useProfile();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [subMenu, setSubMenu] = React.useState(null);
    const open = Boolean(anchorEl);
    const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);
    const mobileMenuId = 'primary-search-account-menu-mobile';

    const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

    const handleClose = () => {
        setAnchorEl(null);
    };
    const handleMobileMenuClose = () => {
        setMobileMoreAnchorEl(null);
    };
    const handleMobileMenuOpen = (event) => {
        setMobileMoreAnchorEl(event.currentTarget);
    };
    const handleClickPage = (event, page) => {
        console.log('>>handleClickPage<<', page);
        setAnchorEl(null);
        if( page.action && page.action.length > 0){
            handleMobileMenuClose();
        }
        if( typeof page.action === 'function'){
            page.action(event);
            return;
        }
        if (page.action && page.action.toUpperCase().indexOf("HTTP") >= 0) {
            if (page.action && page.action.toUpperCase().indexOf("_BLANK") >= 0) {
                window.open(page.action.split(" ")[0], "_blank");
            } else {
                window.open(page.action);
            }
            return;
        } else if (page.action && page.action.indexOf("/") >= 0) {
            navigate(page.action);
            return;
        }


        if (page.menu) {
            setAnchorEl(event.currentTarget);
            setSubMenu(page.menu);
        } else if (page.action) {
            navigate("/pagina/" + page.action);
        }
    }
    function montaTreeMenu(menu, index, label) {
        if (menu.rule && !prof.temAcesso(menu.rule)) {
            return;
        }        
        if( menu.nome === 'Divider'){
            return (
                <Divider />
            )    
        }
        return (
            <TreeItem
                key={index + "_" + label + "_k"}
                itemId={index + "_" + label}
                label={menu.nome}
                onClick={(e) => {
                    e.stopPropagation(); // importante para não conflitar com expansão

                    if (!menu.menu || menu.menu.length === 0) {
                        handleClickPage(e, menu);
                    }
                }}
            >
                {menu?.menu && menu?.menu.map((menu, index) => montaTreeMenu(menu, index, label + "." + menu.id))}
            </TreeItem>
        );
    }
    function montaSubMenuMobile(item){
        return (
            <Menu key={"menu_" + item.id}
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={() =>{
                    handleClose();
                    handleMobileMenuClose();
                }}
            >
                <SimpleTreeView  >
                    {item.menu && item.menu?.map((menu, index) => montaTreeMenu(menu, index, menu.id))}
                </SimpleTreeView>
            </Menu>
        )
    }
    function montaSubMenu(item) {
        return (
            <Menu key={"menu_" + item.id}
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
            >
                <SimpleTreeView  >
                    {item.menu && item.menu?.map((menu, index) => montaTreeMenu(menu, index, menu.id))}
                </SimpleTreeView>
            </Menu>
        )
    }
    const renderMobileMenu = (
        <Menu
            anchorEl={mobileMoreAnchorEl}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            id={mobileMenuId}
            keepMounted
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            open={isMobileMenuOpen}
            onClose={handleMobileMenuClose}
        >
            {menuJson && menuJson.map((menu) => {
                if (menu.rule && !prof.temAcesso(menu.rule)) {
                    // return(<React.Fragment/>);
                    return;
                }
                if(!menu.type){
                    return (
                        <MenuItem key={menu.id} onClick={(e) => {
                            handleClickPage(e, menu);
                            if( menu.action.length > 0 ){
                                handleMobileMenuClose();
                            }
                        }}>
                            {menu.nome}
                            {menu.menu && <ExpandMore/>}
                        </MenuItem>
                    )
                }else if( menu.menu === subMenu){
                    montaSubMenuMobile(menu);
                }
                
            })}

        </Menu>
    );
    return (
        <React.Fragment >
            <Box sx={{ display: { xs: 'flex', md: 'none' } }}>
                <IconButton
                    size="large"
                    aria-label="show more"
                    aria-controls={mobileMenuId}
                    aria-haspopup="true"
                    onClick={handleMobileMenuOpen}
                    color="inherit"
                >
                    <MoreIcon />
                </IconButton>
            </Box>
            <Box sx={{
                flexGrow: 1,
                // display: { xs: 'flex' } 
                display: { xs: 'none', md: 'flex' }
            }} id="id_menu_header">
                {menuJson && menuJson.map((menu) => {

                    if (menu.rule && !prof.temAcesso(menu.rule)) {
                        return;
                    }
                    return (
                        <React.Fragment key={menu.id}>
                            {!menu.type && <Button color="inherit"
                                onClick={(e) => handleClickPage(e, menu)}
                            >
                                {menu.nome}
                            </Button>}
                            {menu.menu === subMenu && montaSubMenu(menu)}
                        </React.Fragment>
                    )
                })}
            </Box>
            {renderMobileMenu}
        </React.Fragment>
    )
}

export default MenuContent;